export default __webpack_public_path__ + "static/media/Honorgrounds_LE.af608872.jpg";